// Client-side constants for different question types

export const HAPPINESS_LABELS: Record<number, string> = {
  1: 'very unhappy',
  2: 'unhappy',
  3: 'neutral',
  4: 'happy',
  5: 'super happy',
};

export const RATE_LABELS: Record<string, Record<number, string>> = {
  'navigation-ease': {
    1: 'very hard',
    2: 'hard',
    3: 'neutral',
    4: 'easy',
    5: 'very easy',
  },
  'revisit-likelihood': {
    1: 'Not likely',
    2: 'Unlikely',
    3: 'Maybe',
    4: 'Very likely',
    5: 'Absolutely',
  },
  'recommend-likelihood': {
    1: 'Never Recommend',
    2: 'Not Sure',
    3: 'Maybe',
    4: 'Recommend',
    5: 'Definitely Recommend',
  },
};

export const DEFAULT_RATE_LABELS: Record<number, string> = {
  1: 'Very poor',
  2: 'Poor',
  3: 'Average',
  4: 'Good',
  5: 'Excellent',
};
